import React from 'react'
import t from 'prop-types'

import Juego from './juego'
import Parametro from './parametro'

class ContenedorIndiceGameGenerator extends React.Component {
    static propTypes = {
        configIndice: t.shape({
            tituloContenedor: t.string,
            juegos: t.array.isRequired
        }).isRequired,
        indexJuego: t.number.isRequired, // index de la unidad actualmente seleccionada
        parametrosSeleccionados: t.array.isRequired, // opciones seleccionadas de cada juego
        onSeleccionarJuego: t.func.isRequired
    }

    renderParametros () {
        const { configIndice, indexJuego, parametrosSeleccionados, onSeleccionarParametro } = this.props
        const juegoSeleccionado = configIndice.juegos[indexJuego]

        return (
            <div className={ `contenedorLeccionesIndice leccionesUd${juegoSeleccionado.numUnidad}`}>
                { juegoSeleccionado.parametros.map( (parametro, index) => <Parametro 
                    key={"juego-" + juegoSeleccionado.id + "-parametro-" + index}
                    index={ index } 
                    {...parametro}
                    value = {parametrosSeleccionados[indexJuego][index] }
                    onSeleccionarParametro={ onSeleccionarParametro } 
                /> )}
            </div>            
        )        
    }

    renderJuegos () {
        const { configIndice, indexJuego, onSeleccionarJuego } = this.props
        return configIndice.juegos.map( (juego, index) => <Juego 
                key={`juego-id-${juego.id}`} 
                {...juego} 
                seleccionado={ index === indexJuego } 
                onSeleccionar={ () => onSeleccionarJuego(index) }
            />
        )
    }
    
    render () {
        const { tituloContenedor } = this.props.configIndice
        return (
            <div className="contenedorIndice">
                { tituloContenedor && <div className="tituloContenedor" dangerouslySetInnerHTML={{__html: tituloContenedor}} /> }
                <div className="contenedorUnidadesIndice">{ this.renderJuegos() }</div>
                { this.renderParametros() } 
            </div>
        )
    }
} 

export default ContenedorIndiceGameGenerator